import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import * as ReactDOM from "react-dom";
import * as React from "react";
import ToastManager from "./ToastManager";
var isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined";
var PORTAL_ID = "react-toast";
var Toaster = /*#__PURE__*/_createClass(function Toaster() {
  var _this = this;
  _classCallCheck(this, Toaster);
  this.closeAll = function () {
    if (_this.removeAll) {
      _this.removeAll();
    }
  };
  this.bindNotify = function (fn, removeAll, closeToast) {
    _this.createNotification = fn;
    _this.removeAll = removeAll;
    _this.closeToast = closeToast;
  };
  this.notify = function (message) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (_this.createNotification) {
      return _this.createNotification(message, options);
    }
  };
  this.close = function (id, position) {
    if (_this.closeToast) {
      _this.closeToast(id, position);
    }
  };
  if (!isBrowser) {
    return;
  }
  var portalElement;
  var existingPortalElement = document.getElementById(PORTAL_ID);
  if (existingPortalElement) {
    portalElement = existingPortalElement;
  } else {
    var el = document.createElement("div");
    el.id = PORTAL_ID;
    el.className = "Toaster";
    if (document.body != null) {
      document.body.appendChild(el);
    }
    portalElement = el;
  }
  ReactDOM.render(React.createElement(ToastManager, {
    notify: this.bindNotify
  }), portalElement);
});
export default Toaster;